export const projectsCategory = [
    {
        title: "Macro Projects",
        description: "Comprises 5 macro projects including 1 component library",
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661670609/mp/mp1.png"
    },
    {
        title: "Mini Projects",
        description: "Comprises 8+ mini projects",
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661670858/mp/mp2.png"
    },
    {
        title: "Portfolios",
        description: "Comprises 2 portfolio",
        img: "https://res.cloudinary.com/nj1508/image/upload/v1661671016/mp/mp3.png"
    }
];